import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../lib/Auth';
import Logo from './Logo';

/**
 * Signing a TV in. The TV app (roku-app/) shows a code and says to come here;
 * whoever is signed in on this phone or computer types it, and the TV gets a
 * session of its own for this account (routes/tv.js). Behind RequireAuth, so
 * someone signed out goes to the login first and comes straight back.
 */
const TvLink = () => {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const [code, setCode] = useState(params.get('code') || '');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const approve = async (event) => {
    event.preventDefault();
    if (busy || !code.trim()) return;
    setBusy(true);
    setError('');
    try {
      await axios.post('/api/tv/link/approve', { code });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not sign the TV in. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="login-card" onSubmit={approve}>
        <div className="login-brand">
          <Logo />
        </div>

        {done ? (
          <>
            <h1 className="login-title">The TV is signed in</h1>
            <p className="login-lede">It will be on the home screen in a moment, as {user?.username}.</p>
            <Link to="/home" className="btn btn--play login-submit">
              Done
            </Link>
          </>
        ) : (
          <>
            <h1 className="login-title">Sign in a TV</h1>
            <p className="login-lede">Enter the code on the TV screen. It signs the TV in as {user?.username}.</p>

            <label className="login-field">
              <span className="login-k">Code</span>
              <input
                type="text"
                className="login-code"
                value={code}
                onChange={(event) => setCode(event.target.value.toUpperCase())}
                placeholder="XXXX-XXXX"
                autoComplete="off"
                autoCapitalize="characters"
                autoCorrect="off"
                spellCheck="false"
                maxLength={12}
                autoFocus
                required
              />
            </label>

            {error && <div className="alert login-alert">{error}</div>}

            <button type="submit" className="btn btn--play login-submit" disabled={busy}>
              {busy ? <span className="play-spin" /> : null}
              {busy ? 'Signing in…' : 'Sign in the TV'}
            </button>
          </>
        )}
      </form>
    </div>
  );
};

export default TvLink;
